import { AxiosRequestConfig, AxiosResponse } from 'axios';

import GetPaginatedResponse from '../../../../Api/CRM/Responses/PaginatedResponse';
import { API_CASINO_AFFILIATES, API_CASINO_AFFILIATES_SUMMARY } from '../../../../crm/casino/pages/Helpers/CrmApiUrls';
import AbstractCasinoCRMApi from '../../AbstractCasinoCRMApi';
import CasinoAffiliateResponse, { CasinoAffiliateSummaryResponse } from '../Responses/CasinoAffiliateResponse';

class CasinoAffiliatesApi extends AbstractCasinoCRMApi {
    public getPaginatedByAffiliateId(
        page: number = 1,
        affiliateId: number,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<CasinoAffiliateResponse>> {
        return this.get(`${API_CASINO_AFFILIATES}/${affiliateId}`, {
            ...config,
            params: { ...config.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<CasinoAffiliateResponse>>) => {
            return response.data;
        });
    }

    public getSummaryByAffiliateId(
        affiliateId: number,
        config?: AxiosRequestConfig
    ): Promise<CasinoAffiliateSummaryResponse> {
        return this.get(`${API_CASINO_AFFILIATES_SUMMARY}/${affiliateId}`, {
            ...config,
            params: { ...config.params },
        }).then((response: AxiosResponse) => {
            return response.data;
        });
    }
}

export default new CasinoAffiliatesApi();
